import { ShelfSet } from '@/Engine/Wardrobe/ShelfSet';
import { $ } from '@/Engine/state';
import { updatePartsForAllShelves } from '@/Engine/eventHandlers/lib/shelfDocking';
import { getRodCap } from '@/lib/createModule';

export const attachRod = (rodShelf: ShelfSet, parentShelf: ShelfSet) => {
    const templates = JSON.parse(JSON.stringify(parentShelf.templates));
    templates.rod = rodShelf.templates.rod;
    templates.rodHolderLeft = rodShelf.templates.rodHolderLeft;
    templates.rodHolderRight = rodShelf.templates.rodHolderRight;
    templates.rodCapLeft = rodShelf.templates.rodCapLeft;
    templates.rodCapRight = rodShelf.templates.rodCapRight;
    templates.assets.push(getRodCap());
    parentShelf.templates = templates;
    parentShelf.updateModels(templates);
    parentShelf.updatePartPosition();
    const rodShelfRack = rodShelf.rackModule;
    const parentRack = parentShelf.rackModule;
    if (rodShelfRack &&
        parentRack &&
        rodShelfRack.uuid !== parentRack.uuid) {
        $.wardrobe.removeModuleByUUID(rodShelfRack.uuid);
        const parentRail = parentRack.railGroup;
        const rodShelfRail = rodShelfRack.railGroup;

        if (parentRail &&
            rodShelfRail &&
            rodShelfRail.uuid !== parentRail.uuid
        ) {
            $.wardrobe.removeRailsByUUID(rodShelfRail.uuid);
        }
    }

    $.wardrobe.removeShelfByUUID(rodShelf.uuid);
    $.selectionBox.unselect();
    $.selectionBoxForBox.unselect();
    $.updated = true;

    // $.dockedShelf = { ...JSON.parse(JSON.stringify(intersectItem.raw)), templates };

};

export function autoRodDocking() {
    let dockingFlag = false;
    $.wardrobe.shelves.forEach((shelf)=> {
        if (shelf.type !== 'shelf') return;
        if (dockingFlag) return;
        const shelfSet = shelf as ShelfSet;
        const collisions = $.checkAllShelfCollisionWithExclude(shelf, shelf.side, []);
        collisions.forEach((collision)=>{
            if (collision.type !== 'shelf') return;
            const collisionShelf = collision as ShelfSet;
            const error = 0.01;
            const firstShelfDeltaX = Math.abs(shelf.position.x - collisionShelf.position.x);
            const firstShelfWidthSum = shelf.width/2 + collisionShelf.width/2;
            const firstOnSameRack = Math.abs(shelf.position.x - collisionShelf.position.x) < error;
            const firstOverlay =
                firstShelfDeltaX < firstShelfWidthSum - error || firstOnSameRack;

            let shelfWithoutRod;
            if (collisionShelf.rodAvailable && !collisionShelf.items.rod)
                shelfWithoutRod = collisionShelf;
            if (!shelfWithoutRod) return;


            const onSameRack = Math.abs(shelf.position.x - collisionShelf.position.x) < error;

            const parentShelf = shelfWithoutRod;
            if (onSameRack &&
                parentShelf &&
                shelfSet.items.rod &&
                !shelf.templates.shelf &&
                Math.abs(shelfSet.width - parentShelf.width) < 0.01
            ) {
                attachRod(shelfSet, parentShelf);
                $.selectionBox.update();
                dockingFlag = true;
                return;
            }

        });
    });
    updatePartsForAllShelves();
    return dockingFlag;
}
